export default __webpack_public_path__ + "static/NotoSansDisplay-VariableFont_wdth,wght-0315f4a2d0795b4b1d0e6104e2b43c93.ttf";